function loadRecaptchaContacts(form) {
    grecaptcha.execute(recaptchaKey, { action: 'recaptcha' }).then(function (token) {
        var recaptchaResponse = document.getElementById('contact_recaptcha');
        recaptchaResponse.value = token;

        var isContactPage = form.hasClass('isContactPage') ? '1' : '0';

        var newsletterSubscribe = $('#contacts-form').find('#contact_newsletter').is(':checked');

        $.ajax({
            url: url__contacts_send+'?locale='+locale+'&cp='+isContactPage,
            data: new FormData(document.getElementById('contacts-form')),// the formData function is available in almost all new browsers.
            type: "post",
            contentType: false,
            processData: false,
            cache: false,
            dataType: "json", // Change this according to your response from the server.
            error: function(err) {
                alert('Ops! SI è verificato un errore. Riprova più tardi.');
            },
            success: function(data) {
                $('form#contacts-form').replaceWith(data.html);
                setTimeout(function () {
                    initFormContacts();
                }, 500);
                if (data.result) {
                    window.dataLayer =  window.dataLayer || [];
                    dataLayer.push({
                        'event': 'submit',
                        'form_submitted': 'contacts'
                    });
                    if (newsletterSubscribe) {
                        dataLayer.push({
                            'event': 'submit',
                            'form_submitted': 'newsletter'
                        });
                    }
                    fbq_trackCustom('submit__contacts');

                    $('#contact_success_modal').modal('show');
                }
            },
            complete: function(){
                // console.log("Request finished.");
            }
        });
    });
}

var submitHandlerContacts = function(e) {
    e.preventDefault();
    e.target.removeEventListener('submit', submitHandlerContacts, false);

    // document.getElementById('contacts-form-submit').classList.add('d-none');
    // document.getElementById('contacts-form-loader').classList.remove('d-none');

    var form = $(this);
    loadRecaptchaContacts(form);
};

function initFormContacts() {
    document.getElementById('contacts-form').addEventListener("submit", submitHandlerContacts);
}

if (document.getElementById('contacts-form')) {
    initFormContacts();
}

$(document).ready(function() {
    $('[name="contact[type]"]').change(function () {
        if($(this).val() == '2') {
            $('#contact_name').attr('placeholder', 'Struttura *');
            $('#contact_last_name').attr('placeholder', 'Referente *');
        }
        else {
            $('#contact_name').attr('placeholder', 'Nome *');
            $('#contact_last_name').attr('placeholder', 'Cognome *');
        }
    });
    $('[name="newsletter[type]"]').change(function () {
        if($(this).val() == '2') {
            $('#newsletter_name').attr('placeholder', 'Struttura *');
            $('#newsletter_last_name').attr('placeholder', 'Referente *');
        }
        else {
            $('#newsletter_name').attr('placeholder', 'Nome *');
            $('#newsletter_last_name').attr('placeholder', 'Cognome *');
        }
    });
});